module.exports = __webpack_public_path__ + "static/media/mandiri.085a5980.png";